import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { Col } from "react-bootstrap";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import * as actions from "MODULES/PurchaseOrders/actions";
import { ACCOUNTING, ADMIN, ROLE, USER } from "MODULES/users/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import LastExchangeWarning from "MODULES/SalesOrders/components/Detail/Panel/Billing/LastExchangeWarning";
import withPurchaseOrder from "MODULES/PurchaseOrders/decorators/withPurchaseOrder";
import {
  VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID,
  VENDOR_CORE_REPAIR_INVOICE_DUE_DATE,
  VENDOR_CORE_REPAIR_INVOICE_NUMBER,
  VENDOR_CORE_REPAIR_INVOICE_PAID
} from "MODULES/PurchaseOrders/constants";
import { Warning } from "MODULES/shared/components";

export function Form(props) {
  const disable = props.nonAccountingUser || !props.isLastExchange;
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <LastExchangeWarning isLastExchange={props.isLastExchange} />
        <FormRow>
          <Col md={6}>
            <Field
              name={VENDOR_CORE_REPAIR_INVOICE_NUMBER}
              component={FormInput}
              label="Repair Invoice #"
              disabled={disable}
            />
          </Col>
          <Col md={6}>
            <Field
              name={VENDOR_CORE_REPAIR_INVOICE_DUE_DATE}
              component={FormInput}
              type="date"
              disabled={disable}
              label="Invoice Due Date"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={6}>
            <Field
              name={VENDOR_CORE_REPAIR_INVOICE_AMOUNT_PAID}
              component={FormInput}
              type="number"
              disabled={disable}
              label="Amount"
            />
          </Col>
          <Col md={6}>
            <Field
              name={VENDOR_CORE_REPAIR_INVOICE_PAID}
              component={FormInput}
              type="date"
              disabled={disable}
              label="Invoice Paid"
            />
          </Col>
        </FormRow>
        {props.hasAssignedCore && (
          <Warning>
            This Repair Invoice is tied to an Exchange PO that was purchased for
            Stock. The core return was from our inventory. You will need to
            create a manual Cost Adjustment to the inventory record associated
            with this Purchase Order.
          </Warning>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  isLastExchange: T.bool,
  nonAccountingUser: T.bool
};

export default connect(
  state => ({
    nonAccountingUser: ![ACCOUNTING, ADMIN].includes(
      state.session.getIn([USER, ROLE])
    )
  }),
  {
    onSubmit: actions.update
  }
)(
  withPurchaseOrder(
    form({
      form: "purchaseOrderBillingDetails"
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/Billing/Form.jsx